export default {
  empresas: [],
  empresasById: {},
  // lastUpdate: "",
  ui: {
    loading: false,
  },
  uiCalc: {
  }
}
